import { AxiosError } from "axios";
import { getNotificationStyle } from "../common/notification";
import { IBayanRequest, IBayanWaybills, ICancelOrClose, IDetailRequest, IUpdateRequest } from "../model/BayanModel";
import AjexPortalService from "./api";
import config from "./config";

const bayanService: string | undefined = process.env.REACT_APP_BAYAN_API_SERVICE;

const trip = config.get('trip')
const driver = config.get('driver')
const close = config.get('close')
const cancel = config.get('cancel')
const create = config.get('create')
const print = config.get('print')
const vehicle = config.get('vehicle')
const update = config.get('update')
const goodTypes = config.get('goodTypes')
const wayBill = config.get('wayBill')
const add = config.get('add')

export const GetBayanDetailService = async (request: IDetailRequest) => {
    try {
        return await AjexPortalService.post(`${bayanService}${trip}/${driver}`,request);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const CloseWaybillService = async (request: Omit<ICancelOrClose, 'reasonId'>) => {
    try {
        //http://localhost:6206/api/v1/trip/close
        return await AjexPortalService.put(`${bayanService}${trip}/${close}`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const PrintWaybillService = async (id?: number) => {
    try {
        return await AjexPortalService.get(`${bayanService}/${trip}/${print}/${id}`)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}


export const CancelWaybillService = async (request: Omit<ICancelOrClose, 'actualDeliveryDate'>) => {
    try {
        //http://localhost:6206/api/v1/trip/driver/1200000098
        return await AjexPortalService.put(`${bayanService}${trip}/${cancel}`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const CreateTipBayanService = async (request: IBayanRequest) => {
    try {
        //{{bayan}}/api/v1/trip/add/waybill
        return await AjexPortalService.post(`${bayanService}${trip}/${create}`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const AddWaybillService = async (request: IBayanWaybills) => {
    try {
        //{{bayan}}/api/v1/trip/add/waybill
        return await AjexPortalService.post(`${bayanService}${trip}/${add}/${wayBill}`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const UpdateDriverService = async (request: IUpdateRequest) => {
    try {
        //{{bayan}}/api/v1/trip/add/waybill
        return await AjexPortalService.put(`${bayanService}${trip}/${update}/${vehicle}/${driver}`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
//{{bayan}}/api/v1/trip/goodtypes
export const GetGoodTypeService = async () => {
    try {
        //{{bayan}}/api/v1/trip/add/waybill
        return await AjexPortalService.get(`${bayanService}${trip}/${goodTypes}`)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
